module.exports = __webpack_public_path__ + "img/1032395499.4b045927.png";